import { z } from 'zod';
import { ILegalClient, legalClientSchema } from '../ILegalClient';
import { legalTransactionSchema } from '../ILegalTransaction';
import {
  ILegalTransactionRelationshipMemberData,
  legalTransactionRelationshipMemberData,
} from './ILegalTransactionRelationshipMemberData';

export const legalTransactionRelationshipMemberSchema = z.object({
  FirstName: z.string().nullable(),
  LastName: z.string(),
  LegalClient: legalClientSchema,
  LegalTransactionArray: z.array(legalTransactionSchema),
  RelationshipRole: z.string().nullable().optional(),
  idLegalClient: z.number(),
  idLegalClientRelationship: z.number(),
  idRelationship: z.number(),
  idRelationshipRole: z.number(),
  ExternalRole: z.string().nullable().optional(),
  isActiveLegalClientRelationship: z.boolean(),
  Joined_At: z.string().nullable().optional(),
  Last_Update: z.string().nullable().optional(),
  data: z.record(z.any()).nullable().optional(),
  Version: z.number().optional(),
});

export type ILegalTransactionRelationshipMember = z.infer<
  typeof legalTransactionRelationshipMemberSchema
>;

export const createMemberFromLegalClient = (
  legalClient: ILegalClient,
  idRelationship: number,
  idRelationshipRole: number,
  data?: ILegalTransactionRelationshipMemberData
): ILegalTransactionRelationshipMember => ({
  FirstName: legalClient.FirstName,
  LastName: legalClient.LastName,
  LegalClient: legalClient,
  LegalTransactionArray: [],
  idLegalClient: legalClient.idLegalClient,
  idLegalClientRelationship: -1,
  idRelationship,
  idRelationshipRole,
  isActiveLegalClientRelationship: true,
  data,
});
